import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import Ajax from '@utils/ajax'
import Appointment from '@model/appointment'
// Service
import { useService } from '@store/service'
const $service = useService()
// Staff
import { useStaff } from '@store/staff'

import { useSettings } from '@store/settings'

import moment from 'moment'

export const useAppointment = defineStore('appointment', () => {
    const $staff = useStaff()
    const $settings = useSettings()

    // Loader.
    const isLoaded = ref(false)

    const appointments = ref([])

    const getAppointments = computed(() => {
        return appointments.value || []
    })

    const fetchAppointments = async (appointment_id = null) => {
        if (appointment_id) {
            const appointment = await Appointment.init(appointment_id).get()
            appointments.value = [appointment]
        } else {
            appointments.value = await Appointment.init().all()

            appointments.value.forEach(appointment => {
                return appointment.meta['checkbox'] = false
            })
        }
    }

    const fetchData = async () => {
        appointments.value = await Appointment.init().all()
        appointments.value.forEach(appointment => {
            return appointment.meta['checkbox'] = false
        })
        isLoaded.value = true

        // Log('APPOINTMENTS', appointments.value)
    }


    const availableSlots = ref([])

    // Fetch available slots
    const fetchAvailableSlots = async (date = null, service_id = null, staff_id = null, customer_id = null) => {
        const response = await Ajax.get('get_available_slots', { date, service_id, staff_id, customer_id })
        if (!response.success) return availableSlots.value = []

        return availableSlots.value = response.data
    }

    const availableDates = ref([])

    // Fetch available dates
    const fetchAvailableDates = async (service_id = null, staff_id = null, max_days = null) => {
        const response = await Ajax.get('get_available_dates', { service_id, staff_id, max_days })
        if (!response.success) return availableDates.value = []

        return availableDates.value = response.data.filter(date => moment(date.date, 'YYYY-MM-DD').isSameOrAfter(moment(), 'day'))
    }


    // Get the appointment by id
    const getById = (appointment_id) => {
        return appointments.value.find(appointment => appointment.appointment_id === appointment_id)
        // return new Appointment(appointment_id)
    }

    const model = (appointment_id = null) => {
        return new Appointment({
            appointment_id: appointment_id
        })
    }

    const bulkDelete = async (ids) => {
        if (!ids || !ids.length) return Toast.warning('Nothing to delete!')
        let response = await Appointment.init().bulkDelete(ids)
        if (response.success) {
            Toast.success(`${ids.length > 1 ? ids.length : ''} ${$settings.labels.appointment?.singular}${ids.length > 1 ? 's' : ''} deleted successfully`)
            await fetchData()
        }
        else {
            Toast.success(response.message)
        }
    }


    const isHoliday = (date, staff_id = 0, service_id = 0) => {
        let day = moment(date, 'YYYY-MM-DD').format('dddd')

        // check if day is holiday
        if (!$settings.businessHours[day]?.enabled) return true


        // check if day off from addons
        if (!$settings.addons.holidays_days_off) return false

        // check if date is holiday
        let holiday = false
        $settings.daysOff?.holidays.forEach(item => {
            if (holiday) return
            if (item.find(h => h.date == date)) return holiday = true
        })
        if (holiday) return true

        // else
        return false


        // const businessDays = Object.entries(prebook_admin.settings.business_hours).map(([key, value]) => {
        //     return value.enabled ? key : null
        // }).filter(Boolean)

        // console.log('businessDays', businessDays, 'date', date, 'staff_id', staff_id, 'service_id', service_id)

        // if (!businessDays.includes(moment(date).format('dddd'))) return false

        // if (!$settings.addons.holidays_days_off) return false

        // const daysOff = []
        // if (prebook_admin.settings.days_off.holidays && prebook_admin.settings.days_off.holidays.length > 0) {
        //     prebook_admin.settings.days_off.holidays.forEach(holiday => {
        //         // It's array. If length is 1, then it's a single day off, if length is 2, then it's a range
        //         if (holiday.length === 1) {
        //             daysOff.push(holiday[0].date)
        //         } else {
        //             const start = moment(holiday[0].date)
        //             const end = moment(holiday[1].date)

        //             while (start.isSameOrBefore(end)) {
        //                 daysOff.push(start.format('YYYY-MM-DD'))
        //                 start.add(1, 'day')
        //             }
        //         }
        //     })
        // }

        // if (daysOff.includes(date)) return false

        // return true
    }

    // export
    return {
        appointments,
        fetchAppointments,
        fetchData,
        availableDates,
        availableSlots,

        // Old code below
        getAppointments,
        getById,
        fetchAvailableSlots,
        fetchAvailableDates,
        isLoaded,
        model,
        bulkDelete,
        isHoliday
    }
})


